import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface RecipeQueryParams {
    search?: string;
    categories?: string[];
    difficulty?: string;
    maxCalories?: number;
    maxPrepTime?: number;
    page?: number;
    limit?: number;
}

export const useRecipes = (params: RecipeQueryParams = {}) => {
    return useQuery({
        queryKey: ['recipes', params],
        queryFn: async () => {
            const searchParams = new URLSearchParams();

            if (params.search) searchParams.append('search', params.search);
            if (params.difficulty) searchParams.append('difficulty', params.difficulty);
            if (params.maxCalories)
                searchParams.append('maxCalories', params.maxCalories.toString());
            if (params.maxPrepTime)
                searchParams.append('maxPrepTime', params.maxPrepTime.toString());
            if (params.page) searchParams.append('page', params.page.toString());
            if (params.limit) searchParams.append('limit', params.limit.toString());
            if (params.categories) {
                params.categories.forEach((cat) => searchParams.append('categories', cat));
            }

            const response = await api.get(`/recipes?${searchParams.toString()}`);
            return response.data;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

export const useRecipe = (recipeId: string) => {
    return useQuery({
        queryKey: ['recipe', recipeId],
        queryFn: async () => {
            const response = await api.get(`/recipes/${recipeId}`);
            return response.data;
        },
        enabled: !!recipeId,
        staleTime: 5 * 60 * 1000,
    });
};

export const useRecipeNutritionCategories = (recipeId: string) => {
    return useQuery({
        queryKey: ['recipe', recipeId, 'nutrition-categories'],
        queryFn: async () => {
            const response = await api.get(`/recipes/${recipeId}/nutrition-categories`);
            return response.data;
        },
        enabled: !!recipeId,
        staleTime: 5 * 60 * 1000,
    });
};
